import React from 'react'
import { useTranslation } from 'react-i18next'
import Images from '../../assets/images'
import './Problems.css'

const TEST_VIDEO_URL = 'https://www.youtube.com/embed/2sisgq9ScDY'

const Problems = () => {
  const { t } = useTranslation()
  const problemItems = t('academyProblems.items', { returnObjects: true }) || []

  return (
    <section className='academy-problems'>
      <div className='academy-problems-content'>
        <div className='academy-problems-top'>
          <div className='academy-problems-image-wrap'>
            <img className='academy-problems-image' src={Images.academy.ballet} alt='academy ballet' />
          </div>

          <div className='academy-problems-copy'>
            <h2>
              {t('academyProblems.title')}
              <span>{t('academyProblems.titleHighlight')}</span>
            </h2>

            <h3>{t('academyProblems.subtitle')}</h3>

            <ul>
              {problemItems.map((item, index) => (
                <li key={index}>
                  <img className='check' src={Images.icons.circleCheck2} alt='check' />
                  <span>{item}</span>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <p className='academy-problems-summary desktop'>
          <img src={Images.tiim.logoTiim} alt='tiim' />
          <span>{t('academyProblems.summaryLine1')}</span>
          <span>{t('academyProblems.summaryLine2')}</span>
        </p>
        <p className='academy-problems-summary mobile'>
          <span>
            <img src={Images.tiim.logoTiim} alt='tiim' />
            {t('academyProblems.summaryLine1') + ' ' + t('academyProblems.summaryLine2')} 
          </span>
        </p>

        <div className='academy-problems-video'>
          <iframe
            title='academy-demo-video'
            src={TEST_VIDEO_URL}
            frameBorder='0'
            allow='accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share'
            referrerPolicy='strict-origin-when-cross-origin'
            allowFullScreen
          />
        </div>
      </div>
    </section>
  )
}

export default Problems
